import * as types from '../constants/profile';
import * as action from './auth';
import api from '../api';

export const fetchProfileStart = () => {
  return {
    type: types.FETCH_PROFILE_START
  };
};

export const fetchProfileSuccess = (payload) => {
  return {
    type: types.FETCH_PROFILE_SUCCESS,
    payload
  };
};

export const fetchProfileFailure = (err) => {
  return {
    type: types.FETCH_PROFILE_FAILURE,
    err
  };
};

export const fetchProfile = (cb) => (dispatch) => {
  dispatch(fetchProfileStart());

  api.get(`api.php?cmd=profile`)
    .then(({ data }) => {
      dispatch(fetchProfileSuccess(data));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchProfileFailure(err))
    });
};

export const fetchTimeZoneStart = () => {
  return {
    type: types.FETCH_TIMEZONE_START
  };
};

export const fetchTimeZoneSuccess = (payload) => {
  return {
    type: types.FETCH_TIMEZONE_SUCCESS,
    payload
  };
};

export const fetchTimeZoneFailure = (err) => {
  return {
    type: types.FETCH_TIMEZONE_FAILURE,
    err
  };
};

export const fetchTimeZone = (cb) => (dispatch) => {
  dispatch(fetchTimeZoneStart());

  api.get(`api.php?cmd=timeZones`)
    .then(({ data }) => {
      const payload = data.data;
      dispatch(fetchTimeZoneSuccess(payload));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchTimeZoneFailure(err))
    });
};

export const fetchCountriesStart = () => {
  return {
    type: types.FETCH_COUNTRIES_START
  };
};

export const fetchCountriesSuccess = (payload) => {
  return {
    type: types.FETCH_COUNTRIES_SUCCESS,
    payload
  };
};

export const fetchCountriesFailure = (err) => {
  return {
    type: types.FETCH_COUNTRIES_FAILURE,
    err
  };
};

export const fetchCountries = (cb) => (dispatch) => {
  dispatch(fetchCountriesStart());

  api.get(`api.php?cmd=countries`)
    .then(({ data }) => {
      const payload = data.data;
      dispatch(fetchCountriesSuccess(payload));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchCountriesFailure(err))
    });
};

export const setProfileStart = () => {
  return {
    type: types.SET_PROFILE_START
  };
};

export const setProfileSuccess = (payload) => {
  return {
    type: types.SET_PROFILE_SUCCESS,
    payload
  };
};

export const setProfileFailure = (err) => {
  return {
    type: types.SET_PROFILE_FAILURE,
    err
  };
};

export const setProfile = (payload, cb) => (dispatch) => {
  dispatch(setProfileStart());

  api.post(`api.php?cmd=setProfile`, payload)
    .then(({ data, status }) => {
      status.code === 200 ? dispatch(setProfileSuccess(data)) : dispatch(setProfileFailure(data.status.message));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(setProfileFailure(err))
    });
};

export const changePasswordStart = () => {
  return {
    type: types.CHANGE_PASSWORD_START
  };
};

export const changePasswordSuccess = (payload) => {
  return {
    type: types.CHANGE_PASSWORD_SUCCESS,
    payload
  };
};

export const changePasswordFailure = (err) => {
  return {
    type: types.CHANGE_PASSWORD_FAILURE,
    err
  };
};

export const changePassword = (payload, cb) => (dispatch) => {
  const {
    oldPswd,
    newPswd,
  } = payload;

  dispatch(changePasswordStart());

  api.post(`api.php?cmd=chPswd&oldPswd=${oldPswd}&newPswd=${newPswd}`)
    .then(({ data, status }) => {
      status.code === 200 ? dispatch(changePasswordSuccess(data)) : dispatch(changePasswordFailure(data.status.message))

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(changePasswordFailure(err));
    });
};

export const deleteProfileStart = () => {
  return {
    type: types.DELETE_PROFILE_START
  };
};

export const deleteProfileSuccess = (payload) => (dispatch) => {
  dispatch({
    type: types.DELETE_PROFILE_SUCCESS,
    payload
  });
  setTimeout(() => dispatch(action.logout()), 2000);
};

export const deleteProfileFailure = (err) => {
  return {
    type: types.DELETE_PROFILE_FAILURE,
    err
  };
};

export const deleteProfile = (cb) => (dispatch) => {
  dispatch(deleteProfileStart());

  api.post(`api.php?cmd=delProfile`)
    .then(({ data }) => {
      dispatch(deleteProfileSuccess(data))

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(deleteProfileFailure(err))
    });
};
